<template>
  <div class="aboutBrief">
    <div class="compText">
      壹心保险代理（浙江）有限公司[简称“壹心保代”]，成立于2018年12月，注册资本金1333.34万元，法人机构注册地为嘉兴。目前旗下拥有八家分公司，近五百名寿险营销队伍，四十多个实力强劲的事务所。公司秉承客户至上、恒守诚信、合规经营、勇于创新的核心价值观，开业至2025年底，在全体壹心人的努力下，公司稳健、快速壮大，累计实现规模保费近17亿，累计实现营业收入达3.25亿元，累计税收贡献3100多万元。
    </div>
    <div class="compText">
      壹心保代以打造“中国最具亲和力的保险人事业平台”为愿景，以“用我们的平台，让保险更简单阳光，成就更多人的幸福”为使命。壹心拥有完整的人才引进、高客人才培养与训练体系、营销管理体系。打造了特色培训中心“壹心学院”，内设管理学院、行销学院、讲师学院、财经学院及科技学院五大人才培养体系，从每位代理人入职、培训、团队组织、荣誉体系都有清晰的规划和有针对性辅导，帮助人才快速成长为一名专业且卓越的保险代理人。公司战略定位以客户为中心的理念，建立“保险+科技+健康”三者协同的服务生态，打造O2O保险新零售模式，真正走进保险3.0时代。
    </div>
    <!-- <div class="compText">
      壹心保代以打造“中国最具亲和力的保险人事业平台”为愿景，以“用我们的平台，让保险更简单阳光，成就更多人的幸福”为使命。
    </div>
    <div class="compText">
      壹心拥有完整的人才引进、高客人才培养与训练体系、营销管理体系。打造了特色培训中心“壹心学院”，内设管理学院、行销学院、讲师学院、财经学院及科技学院五大人才培养体系，从每位代理人入职、培训、团队组织、荣誉体系都有清晰的规划和有针对性辅导帮助人才快速成长为一名专业且卓越的保险代理人。
    </div>
    <div class="compText">
      公司战略定位以客户为中心的理念，建立“保险+ 科技+健康”三者协同的服务生态，打造O2O 保险新零售模式，真正走进保险 3.0时代。
    </div> -->
  </div>
</template>

<script>
  export default {
    name: 'aboutBrief',
    components: {},
    data() {
      return {}
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {}
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  @import "../styles/face";

  .aboutBrief {
    width: 1024px;
    margin: 0 auto;
    .middle {
      display: flex;
      justify-content: center;
      padding: 60px 0;

      .left {
        border-radius: 60px 0px 0px 0px;
        margin-right: 100px;
      }

      .right {
        border-radius: 0px 60px 0px 0px;

        img {
          width: 40px;
          margin-right: 30px;
        }
      }

      .spacial {
        font-family: 'number-special' !important;
      }

      &>div {
        color: #FE7B27;
        background-color: #FBF1EA;
        width: 311px;
        height: 106px;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 50px;
          margin-right: 30px;
        }
      }
    }
  }
</style>